import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ResolvedTypography, TypographySettings } from "@core/data/types/advanced-report";

export interface ReportComponentTypographyDialogData {
    parent: ResolvedTypography;
    value: TypographySettings;
    parentLabel: string;
}

@Component({
    selector: 'pv-report-component-typography-dialog',
    templateUrl: 'report-component-typography.dialog.html',
    styleUrls: ['report-component-typography.dialog.scss'],
})
export class ReportComponentTypographyDialog {

    working: TypographySettings;

    constructor(
        private _dialogRef: MatDialogRef<ReportComponentTypographyDialog>,
        @Inject(MAT_DIALOG_DATA) public data: ReportComponentTypographyDialogData,
    ) {
        this.working = { ...(data.value ?? {}) };
    }

    onChange(value: TypographySettings) {
        this.working = value;
    }

    apply() {
        this._dialogRef.close({ status: true, data: this.working });
    }

    cancel() {
        this._dialogRef.close({ status: false });
    }
}
